// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"5c4c7022","151":"174acb00","453":"e60bf1ad","568":"72ddaffa","797":"c25f7ea9","799":"8152ebab","846":"84c91ff8"}[chunkId] + ".chunk.js";
};